'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002eannotation$002e$002dAnnotation from "./scala.annotation.-Annotation.js";
var $p;
/** @constructor */
function $c_Ldev_cheleb_scalamigen_FieldName(value) {
  this.H7 = null;
  this.H7 = value;
}
export { $c_Ldev_cheleb_scalamigen_FieldName as $c_Ldev_cheleb_scalamigen_FieldName };
$p = $c_Ldev_cheleb_scalamigen_FieldName.prototype = new $j_scala$002eannotation$002e$002dAnnotation.$h_s_annotation_Annotation();
$p.constructor = $c_Ldev_cheleb_scalamigen_FieldName;
/** @constructor */
function $h_Ldev_cheleb_scalamigen_FieldName() {
}
export { $h_Ldev_cheleb_scalamigen_FieldName as $h_Ldev_cheleb_scalamigen_FieldName };
$h_Ldev_cheleb_scalamigen_FieldName.prototype = $p;
function $isArrayOf_Ldev_cheleb_scalamigen_FieldName(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.d3)));
}
export { $isArrayOf_Ldev_cheleb_scalamigen_FieldName as $isArrayOf_Ldev_cheleb_scalamigen_FieldName };
var $d_Ldev_cheleb_scalamigen_FieldName = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ldev_cheleb_scalamigen_FieldName, "dev.cheleb.scalamigen.FieldName", ({
  d3: 1,
  cn: 1,
  co: 1
}));
export { $d_Ldev_cheleb_scalamigen_FieldName as $d_Ldev_cheleb_scalamigen_FieldName };
